import { assertIsNode } from "./assertIsNode";

export function assertIsElement(e: EventTarget | null): asserts e is Element {
  assertIsNode(e);
  if (e.nodeType !== 1) {
    throw new Error(`Element expected`);
  }
}
